import { List, ListItem, ListItemText, Popover } from 'apollo-react';
import React from 'react';

const TextBoxPopover = ({ items = [], onSelect, ...popoverProps }) => {
  return (
    <Popover
      {...popoverProps}
      data-prevent-select
      disableEnforceFocus
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <List>
        {items.map((v, index) => (
          <ListItem key={index} onClick={() => onSelect(v.value)} disabled={v.disabled} button>
            {v.icon && v.icon}
            <ListItemText primary={v.text} />
          </ListItem>
        ))}
      </List>
    </Popover>
  );
};

export default TextBoxPopover;
